interface state extends types.redux.rootReducer {}

export const timestampSelector = ({ timestamp }: state) => timestamp.value;
